import { Grid2, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import UncontrolledSearchSelect from "../../../components/UncontrolledSearchSelect";
import { notifyError, notifySuccess } from "../../../utilities/helper";
import CapsTableComponent from "../../../components/CapsTableComponent/CapsTableComponent";
import { addStrataCapService } from "../../../services/studyCapsService";
import { useNavigate } from "react-router-dom";

const StratsCap = ({
  rowData,
  strataData,
  statusData,
  onLoadData,
  setLoad,
  globalDateFormat,
  access_token,
  userId,
}) => {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedStrata, setSelectedStrata] = useState("");

  useEffect(() => {
    if (rowData && rowData.length > 0) {
      setRows([...rowData]);
    }
  }, [rowData]);

  const isCombinationExists = rows?.some(
    (item) =>
      item.patientStatusTypeId === selectedStatus &&
      item.strataId === selectedStrata,
  );

  const isAddCapDisabled =
    selectedStatus === "" || selectedStrata === "" || isCombinationExists;

  const addRow = async () => {
    if (selectedStatus !== "" && selectedStrata !== "") {
      const data = {
        strataId: selectedStrata,
        statusTypeId: selectedStatus,
        userId: userId,
        globalDateFormat: globalDateFormat,
      };
      try {
        setLoad(true);
        const res = await addStrataCapService(access_token, data);
        if (
          res?.data?.message === "Strata Cap added successfully!" &&
          res?.status == "200"
        ) {
          notifySuccess("Cap added successfully!");
          onLoadData("strata");
        }
      } catch (err) {
        console.log("Error : ", err);
        notifyError(err?.message || "Something went wrong!");
        if (err?.status === 401) {
          navigate("/unAuthorize");
        }
      } finally {
        setSelectedStatus("");
        setSelectedStrata("");
        setLoad(false);
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "30px",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <CapsTableComponent
          isFullScreen={false}
          rows={rows}
          setRows={setRows}
          isNotStatusCap={true}
          dynamicColName={"strata"}
          tabValue={"strata"}
          columnValue="strataName"
          getOnLoadData={onLoadData}
          setLoad={setLoad}
        />
        <div
          style={{
            border: "1px solid lightgrey",
            borderRadius: "8px",
            padding: "10px",
            width: "40%",
          }}
        >
          <p className="page-heading">Add A New Strata Cap</p>
          <Grid2
            container
            alignItems="center"
            justifyContent={"space-between"}
            gap={1}
          >
            <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
              <div>
                <p
                  className="labelStyles"
                  style={{
                    marginTop: "-10px",
                  }}
                >
                  Strata
                </p>
                <UncontrolledSearchSelect
                  data={strataData}
                  optionLabel="strataName"
                  optionKey="strataID"
                  value={selectedStrata}
                  placeholder="Strata"
                  onChange={(selectedValue) => {
                    setSelectedStrata(selectedValue);
                  }}
                />
              </div>
            </Grid2>
            <Grid2 size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}>
              <div>
                <p className="labelStyles">Status</p>
                <UncontrolledSearchSelect
                  data={statusData}
                  optionLabel="patientStatusDescription"
                  optionKey="id"
                  value={selectedStatus}
                  placeholder="Status"
                  onChange={(selectedValue) => {
                    setSelectedStatus(selectedValue);
                  }}
                />
              </div>
            </Grid2>
          </Grid2>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "20px",
            }}
          >
            <Tooltip
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: "14px",
                    padding: "8px 12px",
                  },
                },
              }}
              title={
                selectedStatus === "" || selectedStrata === ""
                  ? "Select strata and status"
                  : isCombinationExists
                    ? "Cap already exists for this Strata and Status"
                    : "Add Cap"
              }
            >
              <span>
                <button
                  className={!isAddCapDisabled ? "create-btn" : "disabled-btn"}
                  disabled={isAddCapDisabled}
                  onClick={addRow}
                >
                  Add Cap
                </button>
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
    </>
  );
};

export default StratsCap;
